import { BaseService, type ResponseMessage } from "@kiddocare-platform/portal-common/base";
import type { Message } from "@kiddocare-platform/portal-common/communication";
import type { Question } from "@kiddocare-platform/portal-common/hub";

export class RepositoryCommunicationService extends BaseService {

  public async GetChatMedia(ticket: string, key: string): Promise<Blob> {
    try {
      const response = await this.AxiosInstance.get(`/parent/communication/chats/${ticket}/${key}`, {
        responseType: 'blob' // Scarichiamo come blob
      });
      return response.data;
    } catch (error: any) {
      this.log.error("GetChatMedia", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async SaveChatMedia(file: Blob, fileName: string, ticket: string): Promise<ResponseMessage<Message>> {
    try {
      const imgBody = new FormData();
      imgBody.append("media", file, fileName);
      const response = await this.AxiosInstance.post(`/parent/communication/chats/${ticket}`, imgBody, {
        headers: {
          "Accept": "application/json",
          "Content-Type": "multipart/form-data"
        }
      });
      return response.data;
    } catch (error: any) {
      this.log.error("SaveChatMedia", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async saveChatMediaQuestion(file: Blob, fileName: string, ticket: string, question: Question): Promise<unknown> {
    try {
      const imgBody = new FormData();
      imgBody.append("media", file, fileName);
      imgBody.append('question', question.name as any);
      const response = await this.AxiosInstance.post(`/parent/communication/chats/${ticket}`, imgBody, {
        headers: {
          "Accept": "application/json",
          "Content-Type": "multipart/form-data"
        }
      });
      return response.data;
    } catch (error: any) {
      this.log.error("SaveChatMediaQuestion", error.stack, JSON.stringify(error));
      throw error;
    }
  }

}
